@if (searchTerms && searchTerms.length) {
  <span class="search-title" translate> Popular search terms </span>
  <div class="terms-list">
    @for (term of searchTerms; track term) {
      <div class="terms-list__item">
        <span> {{ term.title }}</span>
      </div>
    }
  </div>
}
